import API from "@/interceptors/Api";
import type { PaginationResponseType } from "@/features/shared/hooks/hooks/pagination.type";
import type { AccountResponse, AccountType } from "../types/account.types";
// import { getAccountsMock } from "../mocks/get-accounts.mock";

/**
 * Request parameters for fetching accounts
 */
export interface GetAccountsRequest {
  type: AccountType;
  fiscalNumber?: string;
  page?: number;
  size?: number;
}

/**
 * GET: /api/v1/cash-pooling/accounts?type={ORIGIN|DESTINATION}
 * Returns paginated accounts filtered by type
 */
export const getAccounts = async (
  params: GetAccountsRequest,
): Promise<PaginationResponseType<AccountResponse>> => {
  // Real API call
  const { type, fiscalNumber, page = 0, size = 200 } = params;

  const queryParams = new URLSearchParams({
    type,
    ...(fiscalNumber && { fiscalNumber }),
    page: page.toString(),
    size: size.toString(),
  });

  const response = await API.get<PaginationResponseType<AccountResponse>>(
    `/cash-pooling/accounts?${queryParams}`,
  );
  return response as unknown as PaginationResponseType<AccountResponse>;

  // Mock implementation (disabled)
  // return getAccountsMock(params);
};
